import React, { useMemo } from 'react';
import { AppBar, Title } from 'react-admin';
import { Box, Typography } from '@mui/material';
// import { LineChart, Line, ResponsiveContainer } from 'recharts';

// 简单示例数据，可以替换成从 API 拉取
// const sparkData = [
//   { x: 1, y: 10 },
//   { x: 2, y: 18 },
//   { x: 3, y: 12 },
//   { x: 4, y: 22 },
//   { x: 5, y: 16 },
// ];

const CustomAppBar = (props: any) => {
  // 获取用户名
  const userName = useMemo(() => {
    return localStorage.getItem('username') || 'Guest';
  }, []);

  return (
    <AppBar
      {...props}
      elevation={1}
      sx={{
        height: 65,             // 顶部高度，按需调整
        justifyContent: 'center',
        px: 2,
        borderRadius: 0,
        backgroundColor: '#354A5F',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        {/* 左侧: logo + title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img src="/images/companylogo.png" alt="Company" style={{ width: 120, height: 60, objectFit: 'contain' }} />
          <Title defaultTitle="Material Admin" />
        </Box>

        {/* 中间可以放搜索或导航占位 */}
        <Box sx={{ flex: 1 }} />

        {/* 右侧: 欢迎标语 */}
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#ffffff',
            textAlign: 'right',
            mr: 2,
          }}
        >
          Welcome, <strong>{userName}</strong>
        </Typography>

        {/* <Box sx={{ width: 160, height: 40 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={sparkData}>
              <Line type="monotone" dataKey="y" stroke="#ffffff" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </Box> */}
      </Box>
    </AppBar>
  );
};

export default CustomAppBar;